<main class="main">
  <div>
    <div class="mix-match-ads">
      <div class="row" style="margin-left: 5%" *ngIf="!simmerBanner">
        <div class="col-12 simmer-loader-responsive">
          <div class="wrapper-loader">
            <div class="profilePic animate din"></div>
            <div class="comment br animate w100"></div>
            <div class="comment br animate w100"></div>
          </div>
        </div>
      </div>
      <div id="carouselExampleSlidesOnly" class="carousel slide for-desktop-banner-slider" data-ride="carousel" data-pause="false" data-interval="7000">
        <div class="carousel-inner carsouel-margin-top-bottom">
          <ng-container *ngFor="let banner of bannerArray">
            <div class="carousel-item" [ngClass]="banner.active" (click)="redirectBanner(banner)">
              <img [src]="getBannerImg(banner?.desktopBanner)" class="d-block w-100" alt="{{banner?.title}}" style="cursor: pointer;" title="{{banner?.title}}" />
            </div>
          </ng-container>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleSlidesOnly" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleSlidesOnly" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>

      <div id="carouselExampleSlidesOnly1" class="carousel slide for-mobile-banner-slider" data-ride="carousel" data-pause="false" data-interval="7000">
        <!--for Mobile -->
        <div class="carousel-inner carsouel-margin-top-bottom for-mobile-banner">
          <ng-container *ngFor="let banner of bannerArray">
            <div class="carousel-item" [ngClass]="banner.active" (click)="redirectBanner(banner)">
              <img [src]="getBannerImg(banner?.mobileBanner)" class="d-block w-100" alt="{{banner?.title}}" style="cursor: pointer" title="{{banner?.title}}" />
            </div>
          </ng-container>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleSlidesOnly1" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleSlidesOnly1" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>


  <div class="container latest-product-new-section" *ngFor="let category of homeCategory; let i = index">
    <div class="row" [ngClass]="{'up': i > 0}">
      <div class="col-6">
        <div class="heading heading-main">
          <h2 class="title-lg">{{ category?.categoryName }}</h2>
          <p class="headeig_home_sub">{{ category?.content }}</p>
        </div>
      </div>
  
      <div class="col-6">
        <div class="view-more-link cursor">
          <a (click)="routeForViewMoreButtons(category?.categoryName)" [ngStyle]="getColor('text')">View More</a>
          <button type="button" [class]="'swiper-navigation-prev' + (i+1)" [ngStyle]="getColor('button')">
            <i class="fa fa-angle-left"></i>
          </button>
          <button type="button" [class]="'swiper-navigation-next' +(i+1)" [ngStyle]="getColor('button')">
            <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row" id="simmerDB" *ngIf="loader1">
          <div class="col-md-3">
            <div class="wrapper-loader">
              <div class="profilePic animate din"></div>
              <div class="comment br animate w60"></div>
              <div class="comment br animate w80"></div>
              <div class="comment br animate w100"></div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="wrapper-loader">
              <div class="profilePic animate din"></div>
              <div class="comment br animate w60"></div>
              <div class="comment br animate w80"></div>
              <div class="comment br animate w100"></div>
            </div>
          </div>
          <div class="col-md-3 simmer-loader-responsive">
            <div class="wrapper-loader">
              <div class="profilePic animate din"></div>
              <div class="comment br animate w60"></div>
              <div class="comment br animate w80"></div>
              <div class="comment br animate w100"></div>
            </div>
          </div>
          <div class="col-md-3 simmer-loader-responsive">
            <div class="wrapper-loader">
              <div class="profilePic animate din"></div>
              <div class="comment br animate w60"></div>
              <div class="comment br animate w80"></div>
              <div class="comment br animate w100"></div>
            </div>
          </div>
          <div class="col-md-3 simmer-loader-responsive">
            <div class="wrapper-loader">
              <div class="profilePic animate din"></div>
              <div class="comment br animate w60"></div>
              <div class="comment br animate w80"></div>
              <div class="comment br animate w100"></div>
            </div>
          </div>
        </div>
        <swiper *ngIf="isBrowser" #swiperRef class="mySwiper" [slidesPerView]="movileView()" [navigation]="{
            prevEl: '.swiper-navigation-prev' + (i+1),
            nextEl: '.swiper-navigation-next' + (i+1) }" [slidesPerGroup]="mySlidesPerGroup" [spaceBetween]="2" (swiper)="setControlledSwiper($event)" [scrollbar]="{ draggable: true }" [watchSlidesProgress]="true" [autoplay]="{ delay: 500000 }">
          <ng-template swiperSlide *ngFor="let list of productArrays[i]; let j = index">
            <div class="product product-11 text-center" [ngStyle]="{ backgroundColor: getBackGroundColorAccToSpecies(list?.productDetails?.species) }">
              <div class="product-details-action" *ngIf="list.variants.length == 0">
                <a href="javascript:;" *ngIf="!(isShown && actualId == list?.CatalogItemId && showVariance)" (click)="addSelectedVariance(list)">
                  <img src="assets/images/add1.png" width="20" alt="" />
                </a>
              </div>
              <div class="product-details-action" *ngIf="list.variants.length > 1">
                <a style="background: transparent" class="cursor setCart" *ngIf="!(isShown && actualId == list?.CatalogItemId && showVariance)" (click)="showVarianceList(list?.variants, list?.CatalogItemId, list?.isDuplicate)">
                  <img src="assets/images/more-icon.png" alt="" />
                </a>
              </div>
              <figure class="product-media">
                <div *ngIf="list?.productDetails?.species?.length">
                  <div class="tag-name-indica" [ngStyle]="{ 'background-color': list?.productDetails?.species[0]?.speciesColor }">{{getFullName(list?.productDetails?.species[0]['speciesName'] )}}</div>
                  
                </div>
                <div class='discount-price-text' *ngIf="findOfferPre(list) && !(list.myPrice > list.price)">
                  <span class="image_descount_prist-list">{{findOfferPre(list)?.promoCodeDiscount}}% Off </span>
                </div>
  
                <a (click)="redirectToDetailPage(list.productslug)">
                  <img *ngIf="!list?.productDetails.HeroShotUri" loading="lazy" data-src="{{getImageSize3(list?.productDetails?.Assets)}}" alt=" " class="product-image" />
                  <img *ngIf="list?.productDetails.HeroShotUri" loading="lazy" data-src="{{list?.productDetails.HeroShotUri}}" alt=" " class="product-image" />
                </a>

                <div class="Sale_tag_parent">
                  <div class="Sale_new" *ngIf="list.myPrice > list.price">SALE</div>
                </div>

                <div class="thc-tag-new1">
                  <ng-container *ngFor="let compound of compoundList">
                    <span 
                      *ngIf="checkThc(getCompoundValue(compound.min, list?.productDetails), getCompoundValue(compound.max, list?.productDetails))" 
                      class="thc-tag-new">
                      {{ compound.label }}&nbsp;
                      <span *ngIf="checkZero(getCompoundValue(compound.min, list?.productDetails))">
                        {{ getCompoundValue(compound.min, list?.productDetails) }}{{ thcType(list?.productDetails?.ThcType) }}-
                      </span>
                      <span *ngIf="checkZero(getCompoundValue(compound.max, list?.productDetails))">
                        {{ getCompoundValue(compound.max, list?.productDetails) }}{{ thcType(list?.productDetails?.ThcType) }}&nbsp;
                      </span>
                      <span *ngIf="checkZero(getCompoundValue(compound.sum, list?.productDetails))">&nbsp;({{getCompoundValue(compound.sum, list?.productDetails) }})&nbsp;</span>
                    </span>
                  </ng-container>
                </div>
                
                <div id="{{ list?.CatalogItemId }}" *ngIf="varianceArray?.length > 1">
                  <div id="welcomeDiv" class="answer_list" [ngStyle]="{
                      display: isShown && actualId == list.CatalogItemId && showVariance ? 'block' : 'none'
                    }">
                    <input type="button" name="answer" value="" style="background: url(assets/images/close.png)" (click)="showDiv1(list.CatalogItemId)" class="hideproducttag" />
  
                    <h3>Select an option</h3>
                    <div *ngFor="let data of varianceArray; let k = index">
                      <div class="tag" id="tags">
                        <div class="row" (click)="HandleVarinceAddToCartOrNot(data, 1)" style="cursor: pointer">
                          <div class="col-4 MobileCol6" style="padding-right: 0px">
                            <p class="gram"></p>
                            <p class="gram gram2" *ngIf="!data?.productDetails?.NetWeight" style="overflow: hidden" title="{{ data?.productDetails?.ProductName }}">
                              {{ data?.productDetails?.ProductName }}
                            </p>
                            <p class="gram" *ngIf="data?.productDetails?.NetWeight">
                              {{ data?.productDetails?.NetWeight }}
                            </p>
                          </div>
                          <div class="col-8 MobileCol6">
                            <span>
                              <p class="gram" *ngIf="this.VARID != data?._id" style="text-align: right !important">${{ data?.price?.toFixed(2) }}</p>
                            </span>
  
                            <div class="increase-qty" [ngStyle]="{
                                display: this.VARID === data?._id ? 'block' : 'none'
                              }">
                              <div style="cursor: pointer; display: inline-block" *ngIf="data?.finalqty == 1" class="value-button" id="delete" (click)="removeProductFromOfflineCart(data.productId, data)">
                                <span class="" style="font-size: 13px; color: #fff">
                                  <a class="delete-item-product">
                                    <img style="cursor: grab" src="assets/images/bin.png" alt="" style="width: 13px !important; height: auto; display: inline-block" />
                                  </a>
                                </span>
                              </div>
                              <a *ngIf="data.finalqty >= 2">
                                <img style="cursor: grab" src="assets/images/minus-black.png" (click)="increaseDecreaseOfflineProduct(data?.CatalogItemId,data,list)" alt="" />
                              </a>
                              <input *ngIf="data.finalqty >= 1" type="text" [(ngModel)]="data.finalqty" id="qty" value="1" disabled class="form-control" />
  
                              <input *ngIf="data?.finalqty < 1" type="text" id="qty" value="0" disabled class="form-control" />
                              <img style="cursor: grab" src="assets/images/add-black.png" alt="" (click)="addToCartvar(data, true, list)" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </figure>
              <div class="product-body" >
                <div class="product-price">
                  <span *ngIf="list.myPrice > list.price" style="display: inline-block; font-size: 13px; color: #000; font-weight: 600; text-decoration: line-through">
                       {{ list?.myPrice | currency:'USD'}}</span>&nbsp;
                    <span style="font-size: 12px !important; font-weight: 500;"  *ngIf="list.myPrice > list.price">Member’s Price </span>
                     <span [ngClass]="findOfferPre(list) && !(list.myPrice > list.price) ? 'line-through':''">{{ list?.price | currency:'USD' }}</span>&nbsp; 
                     <span style="font-size: 12px !important; font-weight: 500;" *ngIf="findOfferPre(list) && !(list.myPrice > list.price)">Member’s Price </span>
                     <span *ngIf="findOfferPre(list) && !(list.myPrice > list.price)">{{reduceByPercentagePrice(list.price,findOfferPre(list)?.promoCodeDiscount) | currency :'USD'}} </span>
                </div>


                <h5 class="brand-name-product">
                  {{ getBrandName(list) }}
                </h5>
                <h3 class="product-title">
                  <a href="javascript:void(0);" (click)="redirectToDetailPage(list.productslug)">{{ list?.productDetails?.ProductName }}</a>
                </h3>
  
                <div class="row add-strang-item">
                  <div class="col-6" *ngFor="let tag of list?.productDetails?.tags | slice:0:4; let l = index">
                    <div class="add-strang-part1" [ngStyle]="{
                        background: getBackGroundColor(tag)
                      }" *ngIf="tag?.tagName" matTooltip="{{ tag?.tagName }}">
                      {{ tag?.tagName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </swiper>
      </div>
    </div>
  </div>

  <div class="Top_Delivey_content">
    <div class="container">
      <div class="col-md-12" *ngIf="!infoContent?.length">
        <div class="row" id="simmerDB">
          <div class="col-md-4">
            <div class="wrapper-loader">
              <div class="row">
                <div class="col-md-4">
                  <div class="profilePic animate din" style="border-radius: 100%; width: 100px; height: 100px"></div>
                </div>
                <div class="col-md-8">
                  <div class="comment br animate w20"></div>
                  <div class="comment br animate w40"></div>
                  <div class="comment br animate w60"></div>
                  <div class="comment br animate w80"></div>
                  <div class="comment br animate w100"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="wrapper-loader">
              <div class="row">
                <div class="col-md-4">
                  <div class="profilePic animate din" style="border-radius: 100%; width: 100px; height: 100px"></div>
                </div>
                <div class="col-md-8">
                  <div class="comment br animate w20"></div>
                  <div class="comment br animate w40"></div>
                  <div class="comment br animate w60"></div>
                  <div class="comment br animate w80"></div>
                  <div class="comment br animate w100"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 simmer-loader-responsive">
            <div class="wrapper-loader">
              <div class="row">
                <div class="col-md-4">
                  <div class="profilePic animate din" style="border-radius: 100%; width: 100px; height: 100px"></div>
                </div>
                <div class="col-md-8">
                  <div class="comment br animate w20"></div>
                  <div class="comment br animate w40"></div>
                  <div class="comment br animate w60"></div>
                  <div class="comment br animate w80"></div>
                  <div class="comment br animate w100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="infoContent?.length">
        <div class="col-lg-4 col-sm-6" *ngFor="let item of infoContent">
          <div class="icon-box icon-box-card">
            <div class="top_del_img topThreeBoxedLeft">
              <img class="descImg" src="{{ item?.image }}" alt="" />
            </div>
            <div class="icon-box-content topThreeBoxedRight">
              <h3 class="Top_Detail_Content">
                {{ item?.heading }}
              </h3>
              <p class="Top_Detail_Content_p" [innerHTML]="item?.text">
                {{ item?.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="our-brands-section">
    <div class="row" id="simmerDB"></div>

    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="heading heading-main">
            <h2 class="title-lg">Some of Our Favourite Brands</h2>
          </div>
        </div>
      </div>

      <div class="o-brands no">
        <div class="row">
          <div class="col-md-3 col-sm-6" *ngFor="let item of brandArray1">
            <div class="brands" (click)="brandRoute(item?.brandId ? item?.brandId : item?._id)">
              <img src="{{ item?.logo }}" alt="Organnicraft" />
            </div>
          </div>
        </div>
      </div>
      <div class="o-brands">
        <div class="row">
          <div class="col-md-3 col-sm-6" *ngFor="let item of brandArray2">
            <div class="brands" (click)="brandRoute(item?.brandId ? item?.brandId : item?._id)">
              <img src="{{ item?.logo }}" alt="Organnicraft" />
            </div>
          </div>
        </div>
      </div>

      <div class="o-brands">
        <div class="row">
          <div class="col-md-3 col-sm-6" *ngFor="let item of brandArray3">
            <div class="brands" (click)="brandRoute(item?.brandId ? item?.brandId : item?._id)">
              <img src="{{ item?.logo }}" alt="Organnicraft" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="col-md-12" *ngIf="!ourSpecialityContent?.length">
      <div class="row" id="simmerDB">
        <div class="col-md-4">
          <div class="wrapper-loader">
            <div class="row">
              <div class="col-md-8">
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="wrapper-loader">
            <div class="row">
              <div class="col-md-8">
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 simmer-loader-responsive">
          <div class="wrapper-loader">
            <div class="row">
              <div class="col-md-8">
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
                <div class="comment br animate w100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" *ngIf="ourSpecialityContent?.length">
      <div class="col-lg-4 col-sm-6" *ngFor="let item of ourSpecialityContent">
        <div class="icon-box icon-box-card text-center">
          <span class="icon-box-icon">
            <img src="{{ item?.image }}" alt="" />
          </span>
          <div class="icon-box-content">
            <h3 class="icon-box-title">{{ item?.heading }}</h3>
            <p [innerHTML]="item?.text">
              {{ item?.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="social-section-bottom" *ngIf="aboutUsImage?.length">
    <div class="container">
      <div class="row">
        <div class="col-md-4 flexclass">
          <div class="row">
            <div class="col-md-6 padd-right">
              <div class="images-part">
                <img src="{{ aboutUsImage[0] }}" alt="" />
              </div>
            </div>
            <div class="col-md-6 padd-left">
              <div class="images-part">
                <img src="{{ aboutUsImage[1] }}" alt="" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 padd-right">
              <div class="images-part1">
                <img src="{{ aboutUsImage[2] }}" alt="" />
              </div>
            </div>
            <div class="col-md-6 padd-left">
              <div class="images-part1">
                <img src="{{ aboutUsImage[3] }}" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 bg"[ngStyle]="{'background': aboutUs?.backgroundColor ? aboutUs?.backgroundColor:'#000'}" >
          <div class="middle-bottom" [ngStyle]="{'background': aboutUs?.backgroundColor ? aboutUs?.backgroundColor:'#000'}">
            <h1 class="max-lines" [innerHTML]="aboutUs?.heading"></h1>
            <p class="eight-img-boxes max-lines" [innerHTML]="aboutUs?.text"></p>
          </div>
        </div>
        <div class="col-md-4 flexclass">
          <div class="row">
            <div class="col-md-6 padd-right">
              <div class="images-part">
                <img src="{{ aboutUsImage[4] }}" alt="" />
              </div>
            </div>
            <div class="col-md-6 padd-left">
              <div class="images-part">
                <img src="{{ aboutUsImage[5] }}" alt="" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 padd-right">
              <div class="images-part1">
                <img src="{{ aboutUsImage[6] }}" alt="" />
              </div>
            </div>
            <div class="col-md-6 padd-left">
              <div class="images-part1">
                <img src="{{ aboutUsImage[7] }}" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="same-day-delivey" *ngIf="deliveryAreas?.length > 0">
        <div class="container">
          <h3 style="text-align: center;line-height: 26px;">SAME DAY WEED DELIVERY LOCATIONS</h3>
        <p style="text-align: center; font-size: 15px; font-weight: 600;line-height: 26px;">We currently provide timely and reliable marijuana delivery in all of
            <span *ngFor="let item of deliveryAreas; let i = index"><a  [ngClass]="{'cursors': item?.status == 'ACTIVE'}" (click)="routeToDelivery(item)">{{[deliveryAreas?.length - 1] ==i ? ' and':''}} {{item?.regionName}}{{([deliveryAreas?.length - 2] ==i || [deliveryAreas?.length - 1] ==i ) ? '':','}}</a></span>
        </p>
        </div>
  </div>

</main>
<ng-template #slideshow>
  <div class="slideShowLoader"></div>
</ng-template>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.6); z-index: 99999">
  <div class="modal-dialog" role="document" style="top: 40%">
    <div class="modal-content" style="padding: 40px">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Error</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ errorMsg }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal get-verify-number-popup" id="worry_address_searchbar" style="background-size: 100%; background: url(assets/images/bg1.jpg) !important">
  <div class="modal-dialog welcome-to-new-site">
    <div class="modal-content" style="background: transparent; box-shadow: none">
      <div class="modal-body">
        <div class="get-verify">
          <h2>Welcome to our new online store</h2>
          <img src="assets/images/sorry1.png" />
          <h3>we don’t deliver to your area yet</h3>
          <h4>You can still place an order online for in-store Pickup</h4>
          <a href="javascript:;" (click)="openModal(0)">SELECT A STORE NEAR YOU</a>
          <a href="javascript:;" (click)="openModal(1)">TRY DIFFERENT ADDRESS</a>
          <a href="javascript:;" (click)="closePop()" class="get-verified close">
            <img src="assets/images/close1.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="myModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Modal Heading</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">Modal body..</div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Yes</button>

        <button type="button" class="btn btn-secondary" data-dismiss="modal">NO</button>
      </div>
    </div>
  </div>
</div>